// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const FalsePositiveIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 54 54">
    <path
      fill="currentColor"
      d="M53.67 27A26.68 26.68 0 0 0 .33 27a26.68 26.68 0 0 0 53.34 0M27 5.67a21.33 21.33 0 0 1 16.83 34.4l-29.9-29.9c3.6-2.82 8.14-4.5 13.07-4.5M5.67 27c0-4.93 1.68-9.47 4.5-13.07l29.9 29.9A21.33 21.33 0 0 1 5.67 27"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.49 28.47 6.34 6.35a2.68 2.68 0 0 1-3.8 3.8l-6.34-6.35a2.68 2.68 0 0 1 3.8-3.8"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M40.28 18.33a2.7 2.7 0 0 1 0 3.83L23.84 38.6A2.7 2.7 0 1 1 20 34.78l16.45-16.44a2.7 2.7 0 0 1 3.82 0"
      clipRule="evenodd"
    />
  </svg>,
  "FalsePositive",
);
export default FalsePositiveIcon;
